import { CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import React, { ReactNode, useContext, useState } from 'react';
import { Divider, Typography } from 'antd';
import styles from './index.module.scss';
import { ThemeContext, ThemeContextType } from '../../layout';

const {
  wrapper, header, body, footer: footerStyle,
} = styles;

interface WindowProps {
  render?: () => ReactNode | undefined,
  title?: string,
  style?: React.CSSProperties,
  isOpened?: boolean,
  closable?: boolean,
  footer?: ReactNode
  className?: string,
  onClose?: () => void
}

function Window({
  render, title, style, isOpened = true, footer, className, closable = false, onClose,
} : WindowProps) {
  const [opened, setOpened] = useState<boolean>(isOpened);
  const { theme } = useContext<ThemeContextType>(ThemeContext);
  const getHeaderButton = () => {
    if (closable) {
      return <CloseOutlined onClick={onClose} />;
    }
    return opened && !closable
      ? <UpOutlined onClick={() => setOpened((prev) => !prev)} />
      : <DownOutlined onClick={() => setOpened((prev) => !prev)} />;
  };
  return (
    <div className={`${wrapper} ${className ? ` ${className}` : ''}`} style={{ ...style, backgroundColor: theme === 'dark' ? '#141414' : undefined }}>
      {title && (
        <>
          <div className={header}>
            <Typography.Text>{title}</Typography.Text>
            {' '}
            <span>
              {getHeaderButton()}
            </span>
          </div>
          <Divider style={{ margin: 0 }} />
        </>
      )}
      {opened && (
        <>
          <div className={body}>
            {render ? render() : null}
          </div>
          {footer && <div className={footerStyle}>{footer}</div>}
        </>
      )}

    </div>
  );
}

export type { WindowProps };
export default Window;
